import {Component, OnInit, Input, OnChanges, LOCALE_ID, Inject, AfterViewInit} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  CommunicationService,
  SalesService,
  ClientService,
  TypesService,
  ProductService,
  PricingOutput,
  RateService
} from '../../../services';
import {Router} from '@angular/router';
import {OAuthService} from 'angular-oauth2-oidc';
import * as _ from 'lodash';
import {DataHandlerService} from '../../../services/data-handler.service';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIf, NgClass, DecimalPipe, DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-quote-results',
    templateUrl: './quote-results.component.html',
    styles: [],
    providers: [
        { provide: LOCALE_ID, useValue: 'en-AU' },
    ],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgIf, MatFormFieldModule, MatFormFieldModule, MatInputModule, MatInputModule, NgClass, MatButtonModule, MatButtonModule, DecimalPipe, DatePipe]
})
export class QuoteResultsComponent extends WizardWidgetComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public quoteData: any;
  @Input() public isPersonal: any;
  @Input() public loanPurposeType: any;

  public currencyformatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'AUD',
  });

  public dialDownEnabled = true; // IMPT - FLAG to return back implementation of dial down UI

  public rateData: PricingOutput = {};

  public expirationDate: Date;
  public emailTemplatePersonalId = '5c5cd0997f4fd74ab8f6adbd';
  public emailTemplateBusinessId = '55e40367f7d33fde04c75abc';
  public emailTemplateTest = '5c5cd0997f4fd74ab8f6adbd';
  public personalPurposes = [
    'purchase-new-personal',
    'purchase-used-personal',
    'refinance-personal'
  ];
  public loanPurposes = [];
  public insurancePurposes = [];

  private _loanPurposesTypesSlugs = ['car-loan-loan-purpose-types-vx'];
  private _motorLoanPurposeGroupIds = [1, 2];
  private _insurancePurposeGroupId = [5];


  constructor(public dataHandlerService: DataHandlerService,
              private clientService: ClientService,
              private communicationService: CommunicationService,
              private salesService: SalesService,
              private productService: ProductService,
              private typesService: TypesService,
              private router: Router,
              public dialog: MatDialog,
              public oauthService: OAuthService,
              public rateService: RateService,
              public snackBar: MatSnackBar) {
    super(dataHandlerService);
  }

  async ngOnInit() {
    super.ngOnInit();

    this.populatePurposes();
    this.rateService.rateData.subscribe((val) => {
      console.debug('QuoteResultsComponent.rateService.rateParameters');
      this.rateData = val || {};
    });
    this.rateService.rateParameters.subscribe((val) => {
      console.debug('QuoteResultsComponent.rateService.rateParameters');
      // console.log('rate parameters changed?', val);
      if (val.brokeragePaymentType) {
        if (val.brokeragePaymentType === 'paid-by-funder') {
          this.dialDownEnabled = true;
        } else {
          this.dialDownEnabled = false;
        }
      }
    });

  }

  ngOnChanges(changes) {
    if (changes['quoteData'] && changes['quoteData']['currentValue']) {
      if (!this.quoteData['_id']) {
        this.processResults();
      } else {
        this.addVxProducts();
      }
      if (this.quoteData.expiration) {
        this.expirationDate = this.quoteData.expiration;
      }
    }
  }

  populatePurposes() {
    this._loanPurposesTypesSlugs.forEach((slug) => {
      this.typesService.getTypesList(slug)
        .then((results) => {
          results.filter((res) => {
            if (res.ext.Active) {
              if (this._motorLoanPurposeGroupIds.includes(res.ext.LoanPurposeGroupID)) {
                res['productType'] = 'motor-vehicle';
                this.loanPurposes.push(res);
              } else if (this._insurancePurposeGroupId.includes(res.ext.LoanPurposeGroupID)) {
                this.insurancePurposes.push(res);
              } else {
                console.log('[WARN]', 'Unused purpose:', res.id);
              }
            }
          });
        });
    });
  }

  public getPurposeNameBySlug(slug) {
    let name = '';
    this.loanPurposes.forEach((p) => {
      if (p.id === slug) {
        name = p.text;
      }
    });
    return name;
  }

  public getProductType(purpose) {
    for (let i = 0; i < this.loanPurposes.length; i++) {
      if (this.loanPurposes[i].id === purpose) {
        return this.loanPurposes[i]['productType'];
      }
    }
  }

  public getSecurityType(purpose) {
    switch (purpose) {
      case 'purchase-new-business':
      case 'purchase-new-personal':
        return 'new';

      case 'purchase-used-business':
      case 'purchase-used-personal':
        return 'used-dealer';

      case 'refinance-personal':
        return 'used-private';

      default:
        return 'used-dealer';
    }
  }

  public addVxProducts() {
    if (this.quoteData && this.quoteData['data']) {
      this.productService.getMotorVehicleVariationsList(
        'motor-vehicle',
        this.quoteData['data']['app-originator-broker']['broker']['id'],
        this.quoteData['data']['app-quote-details']['purpose'],
        this.getSecurityType(this.quoteData['data']['app-quote-details']['purpose']),
        this.quoteData['data']['app-quote-details']['vehicle']['year'])
        .subscribe((results) => {
            this.quoteData['data']['app-quote-details']['productName'] = results[0].name;
          },
          (err) => {
            console.log(err);
          });
    }
  }

  processResults() {
    if (this.quoteData && this.quoteData.data) {
      // console.log('[quoteData]', this.quoteData);
      this.formGroup.get('monthlyRepayments').patchValue(this.quoteData['data']['app-quote-results']['monthlyRepayments']);
      this.formGroup.get('totalRepayments').patchValue(this.quoteData['data']['app-quote-results']['totalRepayments']);
      if (this.personalPurposes.includes(this.quoteData['data']['app-quote-details']['purpose'])) {
        this.isPersonal = true;
      } else {
        this.isPersonal = false;
      }
    }
  }

  emailQuote() {
    const data: any = this.mapDataToQuote();
    this.clientService.sendEmail(data)
      .subscribe((res) => {
        const email = data[0].template.override.to[0].literal.address;
        const name = data[0].template.override.to[0].literal.displayName;
        this.notify(`The quotation has been mailed successfully to ${name} (${email})`, 'OK');
      });


  }

  getContactDetails() {
    const to = {
      email: this.quoteData['data']['app-customer-details']['email'],
      name: this.quoteData['data']['app-originator-broker']['broker']['name']
    };

    // override the email and name
    const claims: any = this.oauthService.getIdentityClaims();
    to.email = claims.name || to.email;
    to.name = claims.common_name || to.name;
    return to;
  }

  mapDataToQuote() {
    // console.log('[mapDataToQuote]', this.quoteData);
    const id = this.emailTemplateTest; // TODO: replace?

    // Validators.email()

    const to = this.getContactDetails();

    return [{
      template: {
        id,
        name: '',
        jsonModel: {
          values: {
            'Customer-name': to.name,
            'Net-Monthly-Repayment': this.quoteData['data']['app-quote-results']['netMonthlyRepayment'],
            'GST': '',
            'Total-Monthly-Repayment': this.quoteData['data']['app-quote-results']['monthlyRepayments'],
            'Term-In-Months': this.quoteData['data']['app-quote-results']['totalRepayments'],
            // 'Total-Interest': this.quoteData['data']['app-quote-results']['totalInterest'],
            'Interest-Rate': Number(this.rateData.TPSRateToBorrower * 100).toFixed(2),
            'Total-Interests': Number(_.get(this.quoteData, 'data[app-rate].output.TotalInterest', '0')).toFixed(2),
            'Total-Repayments': Number(_.get(this.quoteData, 'data[app-rate].output.TotalRepayment', '0')).toFixed(2),
          },
          model: {
            parties: {
              originators: [
                {name: this.quoteData['data']['app-originator-broker']['originator']['name']}
              ],
              brokers: [
                {name: this.quoteData['data']['app-originator-broker']['broker']['name']}
              ],
              contacts: [
                {name: this.quoteData['data']['app-originator-broker']['contact']['name']}
              ]
            },
            contactName: this.quoteData['data']['app-customer-details']['name'],
            contactEmail: this.quoteData['data']['app-customer-details']['email'],
            contactPhone: this.quoteData['data']['app-customer-details']['phone'],
            selectedProduct: this.quoteData['data']['app-quote-details']['productName'],
            selectedPurpose: this.getPurposeNameBySlug(this.quoteData['data']['app-quote-details']['purpose']),
            selectedDescription: (this.quoteData['data']['app-quote-details']['vehicle']) ? this.quoteData['data']['app-quote-details']['vehicle']['description'] : this.quoteData['data']['app-quote-details']['description'],
            variant: _.get(this.quoteData, 'data[app-quote-details].specs.modelName', ''),
            isGreen: _.get(this.quoteData, 'data[app-rate].output.IsGreen', '').toLowerCase() === 'true' ? 'Yes' : 'No',
            purpose1: {
              amount: this.quoteData['data']['app-quote-details']['totalLoanAmount']
            },
            insuranceAmount: this.getInsuranceAmount(this.quoteData['data']['app-quote-details']['insurances']),
            // brokerageAmount: this.quoteData['data']['app-quote-details']['brokerageFee'],
            brokerage: this.quoteData['data']['app-quote-details']['brokerageFeeCapitalizedCheck'] ? this.quoteData['data']['app-quote-details']['brokerageFee'] : null,
            gstNotFinanced: 0,
            depositAmount: this.quoteData['data']['app-quote-details']['depositTradeAmount'],
            subTotal: this.quoteData['data']['app-quote-details']['subTotal'],
            applicationFee: this.quoteData['data']['app-quote-details']['applicationFee'],
            originationFee: this.quoteData['data']['app-quote-details']['originationFee'],
            expiration: new Date(this.expirationDate).toLocaleDateString(),
          },
        },
        override: {
          to: [{
            literal: {
              address: to.email,
              displayName: to.name
            }
          }]
        }
      }
    }];
  }

  getInsuranceAmount(insurances) {
    let amount = 0;
    insurances.forEach((i) => {
      amount += Number(i.insuranceAmount);
    });
    return amount;
  }

  redirectWizard() {
    // console.log('[redirectWizard]', this.quoteData);
    const sessionData = this.salesService.mapQuoteToApplication(this.quoteData['data']);

    // console.log('sessionData', sessionData);
    if (this.isPersonal) {
      sessionStorage.setItem('wiz-consumer-auto', JSON.stringify(sessionData));
      sessionStorage.setItem('wiz-consumer-auto-step', '0');
      sessionStorage.setItem('wiz-consumer-auto-lead', JSON.stringify(this.quoteData['lead']));
      this.router.navigate(['/application/consumer-auto']);
    } else {
      sessionStorage.setItem('wiz-business-auto', JSON.stringify(sessionData));
      sessionStorage.setItem('wiz-business-auto-step', '0');
      sessionStorage.setItem('wiz-business-auto-lead', JSON.stringify(this.quoteData['lead']));
      this.router.navigate(['/application/business-auto']);
    }
  }

  printPdf() {
    this.openDialog();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(QuoteResultsDialogComponent, {
      hasBackdrop: true,
      data: this.mapToHtml()
    });
  }

  notify(msg, label) {
    const notifyRef = this.snackBar.open(msg, label, {
      duration: 5000,
      panelClass: ['success-snackbar']
    });
  }


  mapToHtml() {
    // console.log('[mapToHtml]', this.quoteData);
    const to = this.getContactDetails();
    return {
      brokerName: to.name,
      customerName: this.quoteData['data']['app-customer-details']['name'],
      originator: this.quoteData['data']['app-originator-broker']['originator']['name'],
      broker: this.quoteData['data']['app-originator-broker']['broker']['name'],
      contact: this.quoteData['data']['app-originator-broker']['contact']['name'],
      customerEmail: this.quoteData['data']['app-customer-details']['email'],
      customerPhone: this.quoteData['data']['app-customer-details']['phone'],
      product: this.quoteData['data']['app-quote-details']['productName'], //
      purpose: this.getPurposeNameBySlug(this.quoteData['data']['app-quote-details']['purpose']),
      description: (this.quoteData['data']['app-quote-details']['vehicle']) ? this.quoteData['data']['app-quote-details']['vehicle']['description'] : this.quoteData['data']['app-quote-details']['description'],
      loanAmount: this.currencyformatter.format(this.quoteData['data']['app-quote-details']['totalLoanAmount']),
      depositAmount: this.currencyformatter.format(this.quoteData['data']['app-quote-details']['depositTradeAmount']),
      subTotal: this.currencyformatter.format(this.quoteData['data']['app-quote-details']['subTotal']),
      applicationFee: this.currencyformatter.format(this.quoteData['data']['app-quote-details']['applicationFee']),
      originationFee: (this.quoteData['data']['app-quote-details']['originationFee']) ? this.currencyformatter.format(this.quoteData['data']['app-quote-details']['originationFee']) : this.currencyformatter.format(0),
      brokerage: (this.quoteData['data']['app-quote-details']['brokerageFeeCapitalizedCheck']) ? this.currencyformatter.format(this.quoteData['data']['app-quote-details']['brokerageFee']) : null,
      netMonthlyRepayment: this.currencyformatter.format(this.quoteData['data']['app-quote-results']['netMonthlyRepayment']),
      totalMonthlyRepayment: this.currencyformatter.format(this.quoteData['data']['app-quote-results']['monthlyRepayments']),
      interestRate: Number(this.rateData.TPSRateToBorrower * 100).toFixed(2),
      variant: _.get(this.quoteData, 'data[app-quote-details].specs.modelName', ''),
      isGreen: _.get(this.quoteData, 'data[app-rate].output.IsGreen', '').toLowerCase() === 'true' ? 'Yes' : 'No',
      totalInterest: _.get(this.quoteData, 'data[app-rate].output.TotalInterest', ''),
      totalRepayment: _.get(this.quoteData, 'data[app-rate].output.TotalRepayment', ''),
      termInMonths: this.quoteData['data']['app-quote-results']['totalRepayments'],
      expiration: this.expirationDate,
    };
  }
}

@Component({
    selector: 'app-quote-results-dialog',
    templateUrl: '../partials/quote-results-dialog.component.html',
    standalone: true,
    imports: [MatDialogModule, MatDialogModule, NgIf, MatButtonModule, MatButtonModule, DatePipe]
})
export class QuoteResultsDialogComponent implements AfterViewInit {

  constructor(
    public dialogRef: MatDialogRef<QuoteResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngAfterViewInit() {
    this.print();
  }

  print() {
    const source = window.document.getElementById('print-section').innerHTML;
    // console.log(this.data);

    const popupWinindow = window.open('');
    popupWinindow.document.open();
    popupWinindow.document.write(`
      <html>
      <head>
      <link rel="stylesheet" type="text/css" href="style.css" />
      <style>
      @media print {
        body {
            -webkit-print-color-adjust: exact;
        }
      }</style>
      </head><body onload="window.print()">${source}</body></html>
      `);
    popupWinindow.document.close();
  }
}
